import { MarketAdType } from '@/types';

export class MarketAdsSearch {
    public adType: MarketAdType;
    public keyword!: string;
    public pageNumber!: number;
    public pageSize!: number;

    constructor() {
        this.keyword = '';
        this.pageNumber = 1;
        this.pageSize = 20;
        this.adType = MarketAdType.ALL;
    }
}
